import type { TPersona } from '@newo/api/gateway';

// Host-side mirror of the props contract owned by the vibe-builder remote
// (apps/vibe-builder/src/contract/remote-entry.contract.ts in
// white-label-frontend). The wire contract is the string values of
// VibeBuilderRenderMode plus the prop shapes; host and remote enums are
// distinct nominal types that never meet across the federation boundary.

export enum VibeBuilderRenderMode {
    Page = 'page',
    Dock = 'dock',
    Mini = 'mini'
}

export type VibeBuilderPageProps = {
    renderMode?: VibeBuilderRenderMode.Page;
    persona: TPersona;
    customerIdn: string;
    clientSecret: string;
    showCallAgentButton?: boolean;
    isExperienceRatingEnabled?: boolean;
};

export type VibeBuilderDockProps = {
    renderMode: VibeBuilderRenderMode.Dock;
    persona: TPersona;
    clientSecret: string;
    isExperienceRatingEnabled?: boolean;
};

export type VibeBuilderMiniChatProps = {
    renderMode: VibeBuilderRenderMode.Mini;
    persona: TPersona;
    clientSecret: string;
    displayName?: string;
    accentColor?: string;
    greetingPhrase?: string;
    agentPictureUrl?: string;
    panelOffsetRight?: number;
    panelOffsetBottom?: number;
};

export type VibeBuilderRemoteProps =
    VibeBuilderPageProps | VibeBuilderDockProps | VibeBuilderMiniChatProps;
